import {UIGameManager} from '../UIGameManager'
import {UIGameAnimation} from '../UIGameEventController'

export abstract class BaseAnimationWrapper implements UIGameAnimation {
    private readonly uiGameManager: UIGameManager
    private readonly startValue: number
    private readonly endValue: number
    private readonly startTime: number
    private readonly duration: number

    constructor(uiGameManager: UIGameManager, startValue: number, endValue: number, duration: number, startingDelay: number = 0) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameAnimation(this)
        this.startValue = startValue
        this.endValue = endValue
        this.startTime = (new Date()).getTime() + startingDelay
        this.duration = duration
    }

    onGameTick() {
        const currentTime = (new Date()).getTime()
        if(currentTime < this.startTime) return

        const timeFactor = this.getLinearInterpolationTimeFactor(currentTime)
        const nextValue = this.getLinearInterpolationNextValue(timeFactor)
        this.setValue(nextValue)

        const didAnimationEnd = timeFactor == 1
        if(didAnimationEnd) this.endAnimation()
    }

    protected abstract setValue(amount: number)

    private endAnimation() {
        this.uiGameManager.eventController.unregisterUIGameAnimation(this)
    }

    private getLinearInterpolationTimeFactor(currentTime: number): number {
        const elapsedTime = currentTime - this.startTime
        const timeFactor = elapsedTime / this.duration
        return Math.min(1, timeFactor)
    }

    private getLinearInterpolationNextValue(timeFactor: number): number {
        return this.startValue * (1 - timeFactor) + this.endValue * timeFactor
    }
}
